import { BaseAddress } from '../../../utils/checkoutState';
import { joinStreetHouseNumber, joinZipCodeCity } from '../../../utils/streetHouseNumber';

const AddressLegend = ({ address }: { address: BaseAddress }) => {
  const { firstName, lastName, additional, state } = address;
  return (
    <p className="billing-address-form__legend">
      {[firstName + ' ' + lastName, joinStreetHouseNumber(address), additional, joinZipCodeCity(address), state]
        .filter(Boolean)
        .join(' · ')}
    </p>
  );
};

export default AddressLegend;
